import { MezoModalProps, VaultDepositFormValue } from "#/shared/types"
import { StepperModal } from "#/ui/Modal/StepperModal"

import VaultDepositStep from "./VaultDepositStep"
import VaultReviewStep from "./VaultReviewStep"

const initialContextValue: VaultDepositFormValue = {
  amount: undefined,
  token: "mBTC",
}

export default function DepositIntoVaultModal(props: MezoModalProps) {
  return (
    <StepperModal
      {...props}
      initialContextValue={initialContextValue}
      steps={[
        {
          title: "Deposit into Vault",
          withCloseButton: true,
          component: VaultDepositStep,
        },
        {
          title: "Deposit into Vault",
          withCloseButton: true,
          component: VaultReviewStep,
        },
      ]}
      overrides={{
        Dialog: {
          style: () => ({
            justifyContent: "start",
          }),
        },
      }}
    />
  )
}
